<template>
    <div class="container offset">
        <form>
            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Cargo atual:</label>
                    <input v-model="memberInfo.permissao" type="name" class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group" v-if="memberInfo.nome_regional != null">
                    <label class="question-style pt-1">Regional:</label>
                    <input v-model="memberInfo.nome_regional" type="text"
                        class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group" v-if="memberInfo.nome_municipio != null">
                    <label class="question-style pt-1">Município:</label>
                    <input v-model="memberInfo.nome_municipio" type="text"
                        class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group">

                    <label class="question-style pt-1">Novo cargo:</label>
                    <select v-model="selectedValue" class="form-control" id="cargoMembro" required>
                        <option :value="6" v-if="(userPerm.id_permissao == 6)">Administrador Estadual</option>
                        <option :value="5" v-if="(userPerm.id_permissao >= 5)">Administrador Regional</option>
                        <option :value="4"
                            v-if="(userPerm.id_permissao >= 4 && (memberInfo.idPermissao != 1 && memberInfo.idPermissao != 3))">
                            Administrador Municipal</option>
                        <option :value="3"
                            v-if="((userPerm.id_permissao >= 5 || userPerm.id_permissao == 3) && (memberInfo.idPermissao != 2 && memberInfo.idPermissao != 4))">
                            Assistente de campo</option>
                        <option :value="2"
                            v-if="(userPerm.id_permissao >= 4 && (memberInfo.idPermissao != 1 && memberInfo.idPermissao != 3))">
                            Gestor Escolar</option>
                        <option :value="1"
                            v-if="((userPerm.id_permissao >= 5 || userPerm.id_permissao == 3) && (memberInfo.idPermissao != 2 && memberInfo.idPermissao != 4))">
                            Aplicador</option>
                    </select>
                </div>

                <div class="form-group" v-if="(selectedValue < 6)">
                    <label class="question-style pt-1" for="regional">Nova Regional:</label>
                    <select v-model="regionaisData" class="form-control" id="regional" required :class="{
                        'disabled-style':
                            (
                                userPerm.id_permissao <= 5
                            )
                    }">
                        <option v-for="regional in regionais" :key="regional.nome" :value="regional.idRegional">
                            {{ regional.nome }}
                        </option>
                    </select>
                </div>

                <div class="form-group" v-if="(selectedValue <= 4) && regionaisData">
                    <label class="question-style pt-1" for="municipio">Novo Município:</label>
                    <select v-model="municipioData" class="form-control" id="municipio" required :class="{
                        'disabled-style':
                            (
                                userPerm.id_permissao <= 4
                            )
                    }">
                        <option v-for="municipio in municipios" :key="municipio.nome" :value="municipio.idMunicipio">
                            {{ municipio.nome }}
                        </option>
                    </select>
                </div>

                <div class="form-group" v-if="(selectedValue == 2) && municipioData">
                    <template v-if="ues.length">
                        <label class="question-style pt-1" for="selectedUE">Nova UE:</label>
                        <select v-model="ueData" class="form-control" id="selectedUE" required>
                            <option v-for="ue in ues" :key="ue.nome" :value="ue.idue">
                                {{ ue.nome }}
                            </option>
                        </select>
                    </template>
                    <label v-else>Não há Unidades Educacionais no município selecionado.</label>
                </div>
            </div>
        </form>
        <div class="button-div d-flex flex-row-reverse justify-content-between mt-5">
            <Button @click="changePermission()" section="salvar" :class="{
                'disabled-style':
                    (
                        userPerm.id_permissao == 6 && selectedValue == memberInfo.idPermissao
                        && ((regionaisData && regionaisData == data.id_regional && !municipioData) || (municipioData && municipioData == data.id_municipio) || (ueData && ueData == data.id_ue))
                    )
                    ||
                    (userPerm.id_permissao == 5 && selectedValue == memberInfo.idPermissao && (municipioData && municipioData == data.id_municipio))
                    || (selectedValue == 5 && (regionaisData == '' || regionaisData == 1))
                    || (selectedValue < 5 && (regionaisData == '' || municipioData == ''))
                    || (selectedValue == 2 && !ueData.length)
            }" value="Salvar Alteração" :isOutline="true" :hasIcon="true" iconName="save" />

            <Button @click="close" section="descartar" value="Fechar" :isOutline="true" :hasIcon="true" iconName="times" />
        </div>
    </div>
</template>

<script>
import Button from '../../components/Button'
import Swal from "sweetalert2";
export default {
    name: "ChangePermission",
    components: {
        Button
    },
    data() {
        return {
            memberInfo: {},
            selectedValue: "",
            regionaisData: "",
            municipioData: "",
            regional: '',
            municipio:'',
            ueData: "",
        };
    },
    props: {
        data: Object,
    },
    computed: {
        userPerm() {
            return this.$store.getters.getUserPerm;
        },
        membroById() {
            return this.$store.getters.getMemberById;
        },
        getRegional() {
            return this.$store.getters.getRegional;
        },
        getMunicipio() {
            return this.$store.getters.getMunicipio;
        },

        /*--------------------------------
        |Retornar as Regionais
        ----------------------------------*/
        regionais() {
            if (this.regional) {
                if (this.userPerm.id_permissao == 5) {
                    return this.$store.getters.getRegionais.filter(element => element.idRegional == this.regional.idRegional);
                }
                else
                    return this.$store.getters.getRegionais.filter(element => element.idRegional == this.regional.id_regional);

            }
            else
                return this.$store.getters.getRegionais;
        },

        /*--------------------------------
        |Retornar os municipios
        ----------------------------------*/
        municipios() {
            return this.$store.getters.getMunicipios;
        },

        ues() {
            return this.$store.getters.getListUE;
        },
    },
    watch: {
        selectedValue() {
            if (this.selectedValue == 6) {
                this.regionaisData = 1;
            }

            if (this.selectedValue == 6 || this.selectedValue == 5 || this.memberInfo.idPermissao == 0) {
                this.municipioData = "";
            }

            if (this.selectedValue == 2) {
                this.municipioData = "";
            }
        },

        async data() {
            this.memberInfo = this.$props.data;
            this.$store.dispatch("setMemberById", this.data.id);
            this.selectedValue = this.memberInfo.idPermissao;

            if (this.memberInfo.id_regional != null) {
                this.regionaisData = this.memberInfo.id_regional;
            }
            if (this.memberInfo.id_municipio != null) {
                const payload = {
                    id_municipio: this.memberInfo.id_municipio,
                };
                await this.$store.dispatch("setRegionalByMunicipio", payload);
                this.regionaisData = this.getRegional.id_regional;
                this.municipioData = this.memberInfo.id_municipio;
            }
            if (this.memberInfo.id_ue != null) {
                const payloadMunicipio = {
                    id_ue: this.memberInfo.id_ue,
                };
                await this.$store.dispatch("setMunicipioByUe", payloadMunicipio)
                this.regionaisData = this.getMunicipio.id_regional;
                this.municipioData = this.getMunicipio.id_municipio;
                this.ueData = this.memberInfo.id_ue;
            }
        },

        /*--------------------------------
        |setar as opçoes de municipios de acordo com a regional selecionada
        ----------------------------------*/
        regionaisData() {
            this.resetMunicipioData();
            const payloadRegMun = {
                id_regional: this.regionaisData
            };
            this.$store.dispatch("setRegionalMunicipios", payloadRegMun);

            if (this.memberInfo.id_municipio != null) {
                this.municipioData = this.memberInfo.id_municipio;
            }

            else if (this.memberInfo.id_municipio == null && this.userPerm.id_permissao <= 4 && this.userPerm.id_permissao != 2) {
                this.municipioData = this.regional.id_municipio;
            }

            else if (this.memberInfo.id_ue != null) {
                this.municipioData = this.getMunicipio.id_municipio;
            }
        },

        async municipioData() {
            this.ueData = "";
            if (this.userPerm.id_permissao >= 4 && this.selectedValue == 2 && this.municipioData) {
                const payload2 = {
                    idMunicipio: this.municipioData
                }
                await this.$store.dispatch('setListUE', payload2)
            }

            if (this.memberInfo.id_ue != null) {
                this.ueData = this.memberInfo.id_ue;
            }
        }
    },
    methods: {
        close() {
            this.$emit('closeModal')
        },
        resetMunicipioData() {
            this.municipioData = "";
            this.ueData = "";
        },
        async changePermission() {

            switch (this.selectedValue) {
                //1 - changing permission to aplicador
                case 1: {
                    const result = await Swal.fire({
                        heightAuto: false,
                        title: "Deseja mesmo alterar a permissão?",
                        text:
                            "Tem certeza que deseja alterar a permissão de " +
                            this.data.nome +
                            " para aplicador?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Sim, tenho certeza",
                    });
                    if (result.isConfirmed) {
                        const payload = {
                            idMunicipio: this.municipioData,
                            idUsuario: this.data.id,
                            idPermissao: "1",
                        };


                        await this.$store.dispatch("setUpdateMember", payload);
                        if (this.$store.getters.getMemberUpdateError) {
                            Swal.fire(
                                "Atualizado!",
                                this.data.nome + " agora é um aplicador.",
                                "success"
                            );
                            this.$emit("emit");
                            this.$emit("closeModal");
                        }
                        else {
                            Swal.fire(
                                "Erro na alteração.",
                                "Não foi possível atualizar a permissão, tente novamente.",
                                "error"
                            );
                        }

                    }
                    break;
                }

                //2 - changing permission to gestor escolar
                case 2: {
                    const result = await Swal.fire({
                        heightAuto: false,
                        title: "Deseja mesmo alterar a permissão?",
                        text:
                            "Tem certeza que deseja alterar a permissão de " +
                            this.data.nome +
                            " para gestor escolar?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Sim, tenho certeza",
                    });
                    if (result.isConfirmed) {
                        const payload = {
                            idMunicipio: this.municipioData,
                            idUe: this.ueData,
                            idUsuario: this.data.id,
                            idPermissao: "2",
                        };

                        await this.$store.dispatch("setUpdateMember", payload);
                        if (this.$store.getters.getMemberUpdateError) {

                            Swal.fire(
                                "Atualizado!",
                                this.data.nome + " agora é um gestor escolar.",
                                "success"
                            );
                            this.$emit("emit");
                            this.$emit("closeModal");
                        }
                        else {
                            Swal.fire(
                                "Erro na alteração.",
                                "Não foi possível atualizar a permissão, tente novamente.",
                                "error"
                            );
                        }
                    }
                    break;
                }

                //3 - changing permission to coordenador/assistente de campo
                case 3: {
                    const result = await Swal.fire({
                        heightAuto: false,
                        title: "Deseja mesmo alterar a permissão?",
                        text:
                            "Tem certeza que deseja alterar a permissão de " +
                            this.data.nome +
                            " para assistente de campo?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Sim, tenho certeza",
                    });
                    if (result.isConfirmed) {
                        const payload = {
                            idMunicipio: this.municipioData,
                            idUsuario: this.data.id,
                            idPermissao: "3",
                        };


                        await this.$store.dispatch("setUpdateMember", payload);
                        if (this.$store.getters.getMemberUpdateError) {
                            Swal.fire(
                                "Atualizado!",
                                this.data.nome + " agora é um assistente de campo.",
                                "success"
                            );
                            this.$emit("emit");
                            this.$emit("closeModal");
                        }
                        else {
                            Swal.fire(
                                "Erro na alteração.",
                                "Não foi possível atualizar a permissão, tente novamente.",
                                "error"
                            );
                        }

                    }
                    break;
                }

                //4 - changing permission to adm municipal
                case 4: {
                    const result = await Swal.fire({
                        heightAuto: false,
                        title: "Deseja mesmo alterar a permissão?",
                        text:
                            "Tem certeza que deseja alterar a permissão de " +
                            this.data.nome +
                            " para administrador municipal?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Sim, tenho certeza",
                    });
                    if (result.isConfirmed) {
                        const payload = {
                            idMunicipio: this.municipioData,
                            idUsuario: this.data.id,
                            idPermissao: "4",
                        };


                        await this.$store.dispatch("setUpdateMember", payload);
                        if (this.$store.getters.getMemberUpdateError) {
                            Swal.fire(
                                "Atualizado!",
                                this.data.nome + " agora é um administrador municipal.",
                                "success"
                            );
                            this.$emit("emit");
                            this.$emit("closeModal");
                        }
                        else {
                            Swal.fire(
                                "Erro na alteração.",
                                "Não foi possível atualizar a permissão, tente novamente.",
                                "error"
                            );
                        }
                    }
                    break;
                }

                //5 - changing permission to adm regional
                case 5: {
                    const result = await Swal.fire({
                        heightAuto: false,
                        title: "Deseja mesmo alterar a permissão?",
                        text:
                            "Tem certeza que deseja alterar a permissão de " +
                            this.data.nome +
                            " para administrador regional?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Sim, tenho certeza",
                    });
                    if (result.isConfirmed) {
                        const payload = {
                            idRegional: this.regionaisData,
                            idUsuario: this.data.id,
                            idPermissao: "5",
                        };


                        await this.$store.dispatch("setUpdateMemberRegional", payload);
                        if (this.$store.getters.getRegionalUpdateError) {
                            Swal.fire(
                                "Atualizado!",
                                this.data.nome + " agora é um administrador regional.",
                                "success"
                            );
                            this.$emit("emit");
                            this.$emit("closeModal");
                        }
                        else {
                            Swal.fire(
                                "Erro na alteração.",
                                "Não foi possível atualizar a permissão, tente novamente.",
                                "error"
                            );
                        }
                    }
                    break;
                }

                //6 - changing permission to adm estadual
                case 6: {
                    const result = await Swal.fire({
                        heightAuto: false,
                        title: "Deseja mesmo alterar a permissão?",
                        text:
                            "Tem certeza que deseja alterar a permissão de " +
                            this.data.nome +
                            " para administrador estadual?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Sim, tenho certeza",
                    });
                    if (result.isConfirmed) {
                        const payload = {
                            idRegional: this.regionaisData,
                            idUsuario: this.data.id,
                            idPermissao: "6",
                        };


                        await this.$store.dispatch("setUpdateMemberRegional", payload);
                        if (this.$store.getters.getRegionalUpdateError) {
                            Swal.fire(
                                "Atualizado!",
                                this.data.nome + " agora é um administrador estadual.",
                                "success"
                            );
                            this.$emit("emit");
                            this.$emit("closeModal");
                        }
                        else {
                            Swal.fire(
                                "Erro na alteração.",
                                "Não foi possível atualizar a permissão, tente novamente.",
                                "error"
                            );
                        }

                    }
                    break;
                }

            }
        }
    },
    async created() {
        if (this.data.id_regional != null) {
            this.regionaisData = this.data.id_regional;
        }
        const loggedPerm = await this.$store.getters.getUserPerm

        /*--------------------------------
        |Obtém todas as regionais com base no usuario selecionado
        ----------------------------------*/
        if (loggedPerm.id_permissao == 5) {
            const payload = {
                idRegional: loggedPerm.id_regional
            };
            await this.$store.dispatch("setRegionalUnica", payload);
            this.regional = await this.$store.getters.getRegionalUnica;
            this.regionaisData = this.regional.idRegional;

        } else if (loggedPerm.id_permissao == 6) {
            await this.$store.dispatch("setRegionais");
        } else if (loggedPerm.id_permissao == 4 || loggedPerm.id_permissao == 3 || loggedPerm.id_permissao == 1) {
            const payloadGetRegionalByMunicipio = {
                id_municipio: loggedPerm.id_municipio
            };
            await this.$store.dispatch("setRegionalByMunicipio", payloadGetRegionalByMunicipio);
            this.regional = await this.$store.getters.getRegional;
            this.regionaisData = this.regional.id_regional;
        }
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    background-color: white;
}

.form-group {
    display: flex;
}

.title-style {
    font-size: 1.5rem;
    font-weight: 600;
    color: #656565;
}

.question-style {
    width: 100%;
    font-size: 1rem;
    font-weight: 500;
    color: #656565;
}

.image-style {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    padding: 1rem;
}

.button-div {
    margin-top: 2rem;
}

.input-personal {
    padding: 0.2rem 0.4rem;
    font-size: 15px;
    font-weight: 400;
    border-radius: 8px;
    background: #FCFCFC;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.11);
    font-weight: lighter;
    padding: 0.2rem 0.4rem;
    box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
}

.disabled-style {
    background-color: #D0D0D0 !important;
    cursor: default;
    pointer-events: none;
}
</style>